module.exports = __webpack_public_path__ + "static/media/footer-logo.c31e7f4c.svg";